import { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

export const useAndroidBackButton = () => {
  const [lastBackPress, setLastBackPress] = useState(0);
  const {t} = useTranslation()
  const timePeriodToExit = 500


  const showToast = (message: string,durationMs: number) => {
        toast(message, {
          duration: durationMs, // 0.7 seconds
          position: 'bottom-center',
          style: {
            background: '#4B5563', // Gray background
            color: '#FFFFFF',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '14px',
          },
        });
      };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      let listener: { remove: () => Promise<void> } | null = null;

      const registerListener = async () => {
        listener = await App.addListener(
          "backButton",
          async ({ canGoBack }: { canGoBack: boolean }) => {
            const currentTime = new Date().getTime();

            // Check for double tap
            if (currentTime - lastBackPress < timePeriodToExit) {
                App.exitApp();
              setLastBackPress(0); // Reset after confirm
            } else {
              // Single tap: navigate back if possible
              if (canGoBack) {
                window.history.back();
                showToast(t('doubleTapToExit'), 1400)
              }
              setLastBackPress(currentTime);
            }
          },
        );
      };

      registerListener();

      return () => {
        if (listener) {
          listener.remove();
        }
      };
    }
  }, [lastBackPress, t]);
};
